import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { AuthService } from '../../../auth/services/auth/auth.service';
import { AppRouteNavigationService } from '../../../core/services/app-route-navigation.service';
import { SponsorOfferClaimNavigationService } from '../services/sponsor-offer-claim-navigation.service';

export const legacyOfferClaimRedirectGuard: CanActivateFn = (route) => {
  const router = inject(Router);
  const appRouteNavigation = inject(AppRouteNavigationService);
  const claimNavigation = inject(SponsorOfferClaimNavigationService);
  const authService = inject(AuthService);

  const shortId = route.paramMap.get('shortId')?.trim();
  if (!shortId) {
    return appRouteNavigation.createUrlTree('/');
  }

  const claimPath = claimNavigation.buildClaimPath(shortId);
  authService.setPostLoginRedirect(claimPath);
  return router.parseUrl(claimPath);
};
